import "./shims/bufferGlobal.js";
import { AppShell } from "./AppShell.js";
import { installBackButtonGuard } from "./backButtonGuard.js";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("#app missing");

installBackButtonGuard();
new AppShell(root);
